// eslint-disable-next-line import/prefer-default-export
export const LOTTIE_LATE_INIT = "c-lottie-late-init";
